import axios from 'axios'

const DEVCYCLE_API_BASE_URL = 'https://bucketing-api.devcycle.com/v1'

export const devcycleApiClient = axios.create({
  baseURL: DEVCYCLE_API_BASE_URL,
  timeout: 60000,
  validateStatus(status) {
    return status > 199 && status < 300
  },
})
